import { render, staticRenderFns } from "./SettingsTasks.vue?vue&type=template&id=ac629f16&scoped=true"
import script from "./SettingsTasks.vue?vue&type=script&lang=js"
export * from "./SettingsTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac629f16",
  null
  
)

export default component.exports